import { computed } from 'vue';
import { FieldMeta } from 'vee-validate';

export function useFormError(
  meta: FieldMeta<unknown>,
  standalone: boolean = false,
) {
  const shouldDisplayErrors = computed(() => {
    return (
      (meta.touched || standalone) &&
      meta.validated &&
      !meta.valid &&
      !meta.pending
    );
  });

  return {
    shouldDisplayErrors,
  };
}
